<template>
  <div>
    email confirm
  </div>
</template>

<script>
export default {
  name: 'EmailConfirm',
};
</script>

<style scoped>

</style>
